import { alpha, Theme } from "@mui/material";

/** Shared typography / list styles for long-form HTML (blog posts, expertise city sections, landing pages). */
export const blogStyles = (theme: Theme) => ({
  "& h2": {
    ...theme.typography.h2,
  },
  "& h3": {
    ...theme.typography.h3,
  },
  "& h4": {
    ...theme.typography.h4,
  },
  "& p": {
    ...theme.typography.body1,
  },
  "& ul": {
    marginBottom: "1rem",
    paddingLeft: "1.5rem",
  },
  "& p + ul": {
    marginBottom: "1rem",
    px: "4rem",
    py: "2rem",
    backgroundColor: alpha(theme.palette.success.main, 0.1),
    borderRadius: `${theme.shape.borderRadius}px`,
    "& li": {
      marginBottom: "1rem",
    },
  },
  "& li": {
    color: theme.palette.text.primary,
    marginBottom: "0.5rem",
    lineHeight: 1.6,
  },
  "& strong": {
    color: theme.palette.primary.main,
    fontWeight: "600",
  },
  "& em": {
    color: theme.palette.text.secondary,
    fontStyle: "italic",
  },
});
